import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// WrestlingIQ profile ids recorded in member notes by the WIQ migration/sync
// (`wiq:wrestler=<id>`, legacy `cashtrack:wiq=<id>`). A member can have more
// than one when WIQ has duplicate profiles for the same person.
export function wiqIdsFromNotes(notes: string | null | undefined): number[] {
  const ids = new Set<number>();
  for (const m of (notes ?? '').matchAll(/(?:wiq:wrestler=|cashtrack:wiq=)(\d+)/g)) ids.add(Number(m[1]));
  return [...ids];
}

export const wiqProfileUrl = (id: number) => `https://www.wrestlingiq.com/wrestlers/${id}`;
